import {useQuery} from '@tanstack/react-query';
import {ActivityEventsService} from '../services/ActivityEventsService';

export const useActivityEvents = () => {
    return useQuery({
        queryKey: ['activity-events'],
        queryFn: ActivityEventsService.fetchAll
    });
};
